import React from 'react';
import { ClipLoader } from 'react-spinners';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <ClipLoader size={18} color={'secondary'} loading={true} />
    </div>
  );
};

export default LoadingSpinner;
